import Repository from "./Repository"
import qs from 'qs';

export const resource = '/opensearch'
export const point_resource = '/points'
export const appid = 'shinrokuden'
export default {
    getResource(param) {

        return this._get(resource, param)
    },
    getPointResource(param){
        return this._get(point_resource, param)
    },
    
    _get(_resource, param) {

        var freeword = param.freeword;
        var facetCondition = param.facetCondition;

        console.log("facetCondition:", _resource, "/" , facetCondition);
        if(!freeword) freeword='';

        

        var params = 
            {
                any: freeword,
                idx: param.idx,
                cnt: param.cnt,
                lat: param.lat,
                lon: param.lon,
                d: this.d(param.resolution),
                minlat: param.heatmap ? param.minlat : null,
                maxlat: param.heatmap ? param.maxlat : null,
                minlon: param.heatmap ? param.minlon : null,
                maxlon: param.heatmap ? param.maxlon : null,
                gridLevel: param.heatmap? this.gridLevel(param.resolution): null,
                heatmap: param.heatmap,
                facetkey: param.facetkey,
                facetvalue: param.facetvalue,
                
                appid: appid,
                format:'json'
            }

        for (var key in facetCondition) {
            if((key === 'from' ||
                key === 'until')){
                if(facetCondition[key]) {
                    var yyyy = facetCondition[key].substring(0,4)
                    var mm = facetCondition[key].substring(4,6)
                    var dd = facetCondition[key].substring(6,8);
                    params[key] = yyyy + '-' + mm + '-' + dd;
                }
            }else{
                params[key] = facetCondition[key];
            }
        }
        if((params['from'] && params['until']) || (!params['from'] && !params['until'])){
            
        }else if(params['from'] && !params['until']){
            params['until'] = '2099-12-31';
        }else{
            params['from'] = '1970-01-01';
        }
        const paramsSerializer = (params) => qs.stringify(params,  { arrayFormat: 'repeat' });

        return Repository.get(_resource, {
            params, paramsSerializer
        }
            
        )
    },
    getOne(uuid) {
        if(!uuid) return ;

        return Repository.get(`${resource}`, {
            params: {
                identifier: uuid,
                appid: appid,
                format:'json'
            }
        })
    },

    gridLevel(resolution){
        console.log(resolution);
        //地図検索以外の補正
        if(resolution == null) return 1;

        if(resolution > 20000) return 1;
        if(resolution > 5000) return 2;
        if(resolution > 2000) return 3;
        if(resolution > 500) return  4;
        if(resolution > 50) return  5;
        if(resolution > 10) return  6;
        if(resolution > 4) return  7;

        return  8;
    },
    d(resolution){
        console.log("d:", resolution);
        //地図検索以外の補正
        if(resolution == null) return 1;

        if(resolution > 20000) return 2000;
        if(resolution > 5000) return 500;
        if(resolution > 2000) return 200;
        if(resolution > 500) return  50;
        if(resolution > 50) return  5;
        if(resolution > 10) return  1;
        if(resolution > 4) return  0.5;

        return  0.1;
    }

}
